import axios from 'axios';
import {AUTH_BASE_URL} from "../app/config";

const isDev = process.env.NODE_ENV === 'development';
const axiosAuth = axios.create({
    baseURL: isDev ? '' : AUTH_BASE_URL,
    headers: {"Access-Control-Allow-Origin": "*"},
    withCredentials: true,
});

export default axiosAuth;
